import { TagStyle } from '@/models/customer-manager/customer-tag'
import { ApprovedStatusType } from '@/models/reservation-approved-status'

export const RoomStatusType = {
  empty: 1,
  checkIn: 2,
  stay: 3,
  checkOut: 4,
  cleaning: 5,
} as const
export type RoomStatusType = (typeof RoomStatusType)[keyof typeof RoomStatusType]

export type RoomIndicatorResponseType = {
  total: TotalType
  inventories: IndicatorInventoryType[]
  roomsEachFloor: RoomListType[]
}

export type TotalType = {
  emptyRoom: number
  checkin: number
  stay: number
  checkoutScheduled: number
  roomNotClean: number
}

export type IndicatorInventoryType = {
  id: string
  roomTypeId: string
  roomTypeName: string
  roomTypeNameEn: string
  roomTypeShortName: string
  remainingCount: number
}

export type RoomListType = {
  floorId: string
  floorName: string
  floorNameEn: string
  rooms: Array<RoomType | undefined>
}

export type ReservationType = {
  guestName: string
  guestNameKana: string
  currentNights: number
  totalNights: number
  hasUnpaidSales: boolean
  checkInDate: string
  checkOutDate: string
  roomAssignStatus: ApprovedStatusType
  reservationId: string
  checkInId: string | undefined
  notes: { memo: string; category: string }[]
  customerTags: TagStyle[]
  pax: {
    male: number
    female: number
    childA: number
    childB: number
    childC: number
    childD: number
    childE: number
    childF: number
    childOther: number
  }
  guestRoomAssignIds: string[]
  stayCount?: number
}

type Preparation = {
  preparationMemo: string
  preparationType: PreparationType
}

export type RoomType = {
  roomId: string
  roomTypeId: string
  roomNumber: number
  roomName: string
  roomNameEn: string
  roomShortName: string
  roomStatus: RoomStatusType
  isAway: boolean
  preparation: Preparation | null
  prevReservation: ReservationType | undefined
  currentReservation: ReservationType | undefined
  nextReservation: ReservationType | undefined
}

export const PreparationType = {
  OutOfService: 0,
  OutOfOrder: 1,
} as const
export type PreparationType = (typeof PreparationType)[keyof typeof PreparationType]
